// extracted by mini-css-extract-plugin
export default {"subject":"index_subject_z-eAq","pic_box":"index_pic_box_lVOpx","pic":"index_pic_EL8G1","trans":"index_trans_kzjng","list":"index_list_r9oNT"};